export default __webpack_public_path__ + "static/media/ic-calendar.0cac19e1.svg";